module.exports = __webpack_public_path__ + "pc/img/career-swiper03.f3511432.webp";